import { FormContextValues } from '@dreryk/react-common';
import { DatePicker } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../../../translations';

type PassportValidToFieldProps = {
   readonly register: FormContextValues['register'];
};

const PassportValidToField = (props: PassportValidToFieldProps): JSX.Element => {
   return (
      <DatePicker
         testId={'passportValidTo'}
         controller={props.register('passportValidTo', { required: true })}
         dayValidators={'dayBeforeToday'}
         label={patientTranslationKeys.passportValidTo}
         placeholder={patientTranslationKeys.datePlaceholder}
         withNavigationArrows
         defaultValue={null}
      />
   );
};

export { PassportValidToField as PassportValidToDateField };
